const zhLists = require('@/assets/lang/zh/index.js')

// 注意：一定是 exports，不是 export，否则会报错，报错信息是下列的中的内容不是 string
module.exports = {
  ...zhLists,
  systemBase: require('./zh-CN/zh-CN-systemBase'),
  label: require('./zh-CN/zh-CN-label'),
  tableHeader: require('./zh-CN/zh-CN-tableHeader'),
  button: require('./zh-CN/zh-CN-button'),
  tip: require('./zh-CN/zh-CN-tip'),
  tabName: require('./zh-CN/zh-CN-tabName'),
  modalTitle: require('./zh-CN/zh-CN-modalTitle')
}